import api from '@/lib/api';

function urlB64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const raw = window.atob(base64);
  const out = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) out[i] = raw.charCodeAt(i);
  return out;
}

export function pushSupported() {
  return typeof navigator !== 'undefined' && 'serviceWorker' in navigator
    && 'PushManager' in window && 'Notification' in window;
}

export function permissionState() {
  return pushSupported() ? Notification.permission : 'unsupported';
}

async function getRegistration() {
  const existing = await navigator.serviceWorker.getRegistration('/sw.js');
  return existing || navigator.serviceWorker.register('/sw.js');
}

export async function currentSubscription() {
  if (!pushSupported()) return null;
  const reg = await navigator.serviceWorker.getRegistration('/sw.js');
  if (!reg) return null;
  return reg.pushManager.getSubscription();
}

export async function enablePush() {
  if (!pushSupported()) throw new Error('Push is not supported on this browser.');
  const perm = await Notification.requestPermission();
  if (perm !== 'granted') throw new Error('Notification permission was blocked.');
  const reg = await getRegistration();
  await navigator.serviceWorker.ready;
  const { data } = await api.get('/push/vapid-public');
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlB64ToUint8Array(data.data.public_key),
    });
  }
  await api.post('/push/subscribe', { subscription: sub.toJSON() });
  return true;
}

export async function disablePush() {
  const sub = await currentSubscription();
  if (sub) {
    try { await api.post('/push/unsubscribe', { endpoint: sub.endpoint }); } catch (e) { /* ignore */ }
    try { await sub.unsubscribe(); } catch (e) { /* ignore */ }
  }
  return true;
}

export async function sendTestPush() {
  await api.post('/push/test');
}
